<template>
    <div class="editor-tools">
        <div class="upload-panel">
            <div class="editor-btn icon-tools-upload" title="上传数据">
            </div>
            <div class="editor-btn icon-tools-city" title="加载行政区划">
            </div>
            <div class="editor-btn icon-tools-key" title="数据密钥">
            </div>
        </div>
        <div class="utils-panel">
            <div class="editor-btn icon-tools-marker" title="添加标注" @click="handDrawMarker">
            </div>
            <div class="editor-drawing-line editor-btn icon-drawing-line">

                <div class="draw-line-layout dropdown">
                    <div class="editor-btn icon-drawing-line-noraml" title="添加线路" @click="handDrawPolyline"></div>
                    <div class="editor-btn icon-drawing-marker-road" title="沿路划线" @click="handDrawPolyline"></div>
                </div>


            </div>
            <div class="editor-btn icon-tools-circle" title="添加圆形区域" @click="handDrawCircle">
            </div>
            <div class="editor-btn icon-tools-region" title="添加区域" @click="handDrawPolygon">
            </div>
        </div>
        <div class="utils-panel ">
            <div class="editor-btn icon-circle-select" title="圆形查询" @click="handDrawMarker">
            </div>
        </div>
        <div class="filter-panel">
            <div class="editor-filter editor-btn icon-tools-filter">


                <div class="filter-search-layout dropdown">
                    <div class="editor-btn icon-tools-filter-box" title="多边形选择" @click="handDrawPolygon">
                    </div>
                    <div class="editor-btn icon-tools-filter-circle" title="圆形选择" @click="handDrawCircle">
                    </div>
                </div>


            </div>
            <div class="editor-measure editor-btn icon-tools-measure">


                <div class="measure-control dropdown">
                    <div ref="linearMeasure" class="editor-btn icon-tools-measure-line" title="距离量算"
                        @click="handMeasureDistance">
                    </div>
                    <div ref="polygonMeasure" class="editor-btn icon-tools-measure-area" title="面积量算"
                        @click="handMeasureArea">
                    </div>
                </div>


            </div>
            <div class="search-panel editor-btn icon-tools-search" title="搜索" @click="showSearch = !showSearch">
            </div>



            <div class="editor-search-layout" v-show="showSearch">
                <div class="editor-input-group">
                    <span class="icon-glyphicon-remove editor-reset-search-btn"></span>
                    <!-- <span role="status" aria-live="polite" class="ui-helper-hidden-accessible"></span> -->
                    <input type="text" class="editor-search-input" placeholder="请输入关键字进行搜索" autocomplete="off">
                    <span class="editor-input-group-btn">
                        <button class="editor-search-btn" type="button">搜索</button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { MapUtils } from '@/utils/mapUtils';
import { useMapStore } from '@/stores/mapStore';
import { addDescription } from "@/api/Common";




export default {
    name: 'EditorTools',
    data() {
        return {
            mapStore: null,
            showSearch: false,
        }
    },
    mounted() {
        this.mapStore = useMapStore();
        // let linearMeasureTool = MapUtils.bindLinearMeasure(this.$refs.linearMeasure);
        // this.mapStore.addControl(linearMeasureTool);

        // let polygonMeasureTool = MapUtils.bindPolygonMeasure(this.$refs.polygonMeasure);
        // this.mapStore.addControl(polygonMeasureTool);

    },
    methods: {


        handMeasureDistance() {
            this.mapStore.measureDistance();
        },
        handMeasureArea() {
            this.mapStore.measureArea();
        },
        handDrawPolyline() {
            let that = this;
            this.mapStore.startDraw('polyline', (drawLayer, removeObject) => {
                that.mapStore.enableEditObject(
                    drawLayer,
                    { title: '新对象', description: '', type: '1' },
                    that.mapStore.selectLayerCard
                );
            });
        },
        handDrawPolygon() {
            let that = this;
            this.mapStore.startDraw('polygon', (drawLayer, removeObject) => {
                that.mapStore.enableEditObject(
                    drawLayer,
                    { title: '新对象', description: '', type: '2' },
                    that.mapStore.selectLayerCard
                );
            });
        },
        handDrawRectangle() {
            this.mapStore.startDraw('rectangle', (e) => {

            });
        },
        handDrawCircle() {
            this.mapStore.startDraw('circle', (e) => {

            });
        },
        handDrawMarker() {

            let that = this;
            this.mapStore.startDraw('marker', (drawLayer, removeObject) => {
                that.mapStore.enableEditObject(
                    drawLayer,
                    { title: '新对象', description: '', type: '0' },
                    that.mapStore.selectLayerCard
                );
            });
        },
        handDrawCirclemarker() {
            this.mapStore.startDraw('circlemarker', (e) => {

            });
        },

        handMeasureClear() {

        }

    }
}

</script>

<style scoped>
.editor-tools {
    height: 30px;
}

.editor-btn {
    float: left;
    position: relative;
    top: 2px;
    margin: 0px 4px;
    cursor: pointer;
}

.upload-panel .editor-btn {
    top: 4px !important;
}

.dropdown {
    display: none;
}

.editor-search-layout {
    position: absolute;
    top: 32px;
    right: 0;
    width: 356px;
    border: 1px solid #aaa;
    border-radius: 5px;
    background-color: #fff;
    padding: 6px;
}

.editor-input-group {
    position: relative;
    display: table;
    border-collapse: separate;
}

.editor-reset-search-btn {
    position: absolute;
    top: 4px;
    right: 40px;

    font-size: 16px;
    z-index: 4;
    cursor: pointer;
}

.editor-input-group-btn {
    position: relative;
    font-size: 0;
    white-space: nowrap;
    display: table-cell;
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
}

.editor-search-btn {
    background-color: #0095ff;
    border-color: #0095ff;
    position: relative;
    margin-left: -1px;
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #ffffff;
}

.editor-search-btn:hover {
    background-color: #428bca;
    border-color: #357ebd;
}

.editor-search-input {
    height: 22px;
    font-size: 12px;
    padding: 0 8px;
    padding-right: 24px;
    color: #576d8b;
    position: relative;
    z-index: 2;
    float: left;
    width: 100%;
    margin-bottom: 0;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;

    display: table-cell;
}

.editor-search-input:focus {
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)
}

.upload-panel,
.utils-panel,
.filter-panel {
    position: relative;
    float: left;
    margin-right: 2px;
    background-color: #f5f7fa;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.23);
    border-radius: 2px;
    width: auto;
    height: 30px;
    padding: 0px 4px;
}

.dropdown {
    position: absolute;
    top: 24px;
    padding-top: 5px;
    width: 30px;
    background-color: #f5f7fa;
    left: -4px;
    border-top: 0;
    height: auto;
    -webkit-transition: all 0.15s ease-in-out;
    -moz-transition: all 0.15s ease-in-out;
    -o-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
}

.dropdown .editor-btn {
    margin: 2px 0px;
}

.editor-drawing-line:hover .dropdown,
.dropdown:hover {
    display: inline-block;
}

.editor-filter:hover .dropdown,
.dropdown:hover {
    display: inline-block;
}

.editor-measure:hover .dropdown,
.dropdown:hover {
    display: inline-block;
}
</style>